import React, { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import PropTypes from "prop-types";
import dynamic from 'next/dynamic';
import SEOHead from "@/components/SEOHead/SEOHead";
import Header from "@/components/Header/Header";
import SupportStyles from "@/components/SupportSection/SupportStyles";
import BreadcrumbsNav from "@/components/SupportSection/shared/SupportBreadcrumbs";
import SupportSideNav from "@/components/SupportSection/shared/SupportSideNav";
import FooterComponent from '@/components/Footer/FooterComponent';
import PageWrapperStyles from "@/components/SupportSection/shared/PageWrapper/PageWrapperStyles";
import { isChatHours } from "@/services/isChatHours";

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const PageWrapper = ({
  children,
  submitting,
  data,
  noPadding,
  breadcrumb = '',
}) => {

  const {
    meta_description: metaDescription,
    page_title_tag: pageTitle,
    phone_number_setup,
    additional_questions,
    lead_values,
    paid_campaign
  } = data;
  const [pathname, setPathname] = useState('');
  const [isChatOpen, setIsChatOpen] = useState(false);
  const router = useRouter();


  useEffect(() => {
    if (window && document) {
      setPathname(router.pathname)
    }
  }, []);

  useEffect(() => {
    const getHours = async () => {
      // Get the open hours, if not open the chat will not be available
      const isOpen = await isChatHours();
      setIsChatOpen(isOpen);
    };

    if (pathname === "/support/contact-us") {
      getHours();
    }
  }, [pathname]);

  return (
    <PageWrapperStyles>
      <SEOHead>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
        {pathname === '/support/contact-us' && isChatOpen &&
          <script
            dangerouslySetInnerHTML={{
              __html: `
          drift.on("ready", function(api) {
            drift.api.startInteraction({ 
              interactionId: 348484,
              goToConversation: false 
            });
          });
          `
            }}
          />
        }
        {pathname === '/support/contact-us' && isChatOpen &&
          <script
            dangerouslySetInnerHTML={{
              __html: `
            (function() {
              var DRIFT_CHAT_SELECTOR = '.drift-open-chat'
              function ready(fn) {
                if (document.readyState != 'loading') {
                  fn();
                } else if (document.addEventListener) {
                  document.addEventListener('DOMContentLoaded', fn);
                } else {
                  document.attachEvent('onreadystatechange', function() {
                    if (document.readyState != 'loading')
                      fn();
                  });
                }
              }
              function forEachElement(selector, fn) {
                var elements = document.querySelectorAll(selector);
                for (var i = 0; i < elements.length; i++)
                  fn(elements[i], i);
              }
              function openChat(driftApi, event) {
                event.preventDefault();
                driftApi.openChat();
                return false;
              }
              ready(function() {
                drift.on('ready', function(api) {
                  var handleClick = openChat.bind(this, api)
                  forEachElement(DRIFT_CHAT_SELECTOR, function(el) {
                    console.log('click here');
                    el.addEventListener('click', handleClick);
                  });
                });
              });
            })();
            `
            }}
          />
        }
      </SEOHead>
      <Header
        phone_number={phone_number_setup}
        AdditionalQuestions={additional_questions}
        leadValues={lead_values}
        PaidCampaign={paid_campaign}
      // hideSchedulerHeader={hideSchedulerHeader}
      />
      <SupportStyles noPadding={noPadding}>
        <BreadcrumbsNav noPadding={noPadding} breadcrumb={breadcrumb} />
        <section className={`content-container ${submitting ? "is-loading" : ""}`}>
          {children}
          <SupportSideNav noPadding={noPadding} />
        </section>
        <FooterNewsModal />
        <FooterComponent phone_number={phone_number_setup} />
      </SupportStyles>
    </PageWrapperStyles>
  );
};

PageWrapper.propTypes = {
  children: PropTypes.node,
  data: PropTypes.object,
  submitting: PropTypes.bool,
};

export default PageWrapper;